import { render, staticRenderFns } from "./ssn.vue?vue&type=template&id=1ab5828e"
import script from "./ssn.vue?vue&type=script&lang=js"
export * from "./ssn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports